<template>
    <div class="share-item clearfix" @click="shareLink(share.act_id)">
        <div class="share-item-left" v-html="timeFormat(share.add_time)">
            <!--<span class="share-time-day"><em>29</em><br>5月</span>
            <span>-2019-</span-->>
        </div>
        <div class="share-item-right">
            <p :class="{'word-nowrap':!isDown}">{{share.description}}</p>
            <p v-if="share.description.length>25"><span :class="{'word-color':isDown}" @click="arrowDirection" ref="direction"><img :src="img" alt="">显示全文</span>
            </p>
            <ul class="share-img-flex" v-if="share.image_url.length>0" :class="{'share-img-flex':share.image_url.length===4}">
                <li v-for="(n,i) in share.image_url" :key="i"><img :src="weburl+n" alt=""></li>
            </ul>
            <span class="down0"></span>
        </div>

    </div>
</template>

<script>
    import down from '../../assets/images/endPage/down.png';
    import up from '../../assets/images/endPage/up.png';
    export default {
        name: "shareItem",
        props:['share'],
        inject:['stopPropagation'],
        data() {
            return {
                img: down,
                isDown: false,
                date:''

            }
        },
        created(){
            // console.log(this.share.description.length)
        },
        methods: {
            arrowDirection() {
                this.stopPropagation();
                const name = this.$refs.direction.className;
                if (name === '') {
                    this.isDown = true;
                    this.img = up;

                } else {
                    this.isDown = false;
                    this.img = down;
                }

            },
            timeFormat(timeFormat) {
                var t_html = '';
                var time = new Date(timeFormat * 1000);
                var year = time.getFullYear();
                var month = time.getMonth() + 1;
                var date = time.getDate() < 10? '0'+ time.getDate() :time.getDate();
                t_html += '<span class="share-time-day"><em>'+date+'</em><br>'+month+'月</span>\n' +
                    '            <span>-'+year+'-</span>';
                return t_html;
            },
            shareLink (id){
                this.stopPropagation();
                // this.$router.push({path: `/shareDetail/${id}`})
            }

        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            }
        },
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common';

    .clearfix:after {
        content: '';
        display: block;
        zoom: 1;
        clear: both;
        position: relative;
    }

    .share-item {
        width: 100%;
        background: @font-primary;
        .border-radius(5px);
        margin-bottom: 1rem;
        .box-sizing;
        padding: 1rem;
        & > div {
            float: left;

            &.share-item-left {
                width: 14%;
                margin-right: 4%;
                text-align: center;
                @media(min-width:780px){
                    width: 98px;
                }
                /*span {
                    color: @brick_red;
                    font-size: 0.9rem;
                    &.share-time-day {
                        background: @brick_red;
                        color: @font-primary;
                        width: 100%;
                        letter-spacing: 2px;
                        .border-radius(4px);
                        display: block;
                        padding: 6px 0;
                        margin-bottom: 5px;
                        font-size: 0.6rem;
                        line-height: 15px;
                        em {
                            font-size: 200%;
                            font-style: normal;
                        }
                    }
                    @media (min-width: 760px) {
                       font-size: 1.4rem;
                        &.share-time-day {
                            width: 100%;
                            margin-bottom: 5px;
                            font-size: 1.2rem;
                            line-height: 26px;
                            padding: 15px 0;

                        }
                    }
                }*/
            }
            &.share-item-right {
                width: 82%;

                p {
                    line-height: 22px;
                    margin-bottom: 10px;
                    @media (min-width: 760px) {
                        font-size: 1.4rem;
                        line-height: 32px;
                    }
                    &:nth-of-type(1) {
                        &.word-nowrap {
                            overflow: hidden;
                            display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示 。
                            text-overflow: ellipsis; // 可以用来多行文本的情况下，用省略号“...”隐藏超出范围的文本 。
                            -webkit-box-orient: vertical; // 设置或检索伸缩盒对象的子元素的排列方式 。
                            -webkit-line-clamp: 2;
                        }

                    }
                    &:nth-of-type(2) {
                        line-height: 20px;
                        height: 20px;
                        span {
                            display: inline-block;
                            float: right;
                            color: @subject_color;
                            font-size: 0.8rem;
                            img {
                                width: 17px;
                                vertical-align: middle;
                                margin-right: 4px;
                            }
                            &.word-color {
                                color: @bg;
                            }
                            @media (min-width: 760px) {
                                font-size: 1rem;
                                img{
                                    width: 20px;
                                }

                            }
                        }
                    }

                }
                .share-img-flex {
                    display: flex;
                    flex-wrap: wrap;
                    li {
                        width: 80px;
                        margin-right: 5px;
                        height: 80px;
                        margin-bottom: 5px;
                        img {
                            width: 100% ;
                            height: 100%;
                        }
                        @media (min-width: 760px) {
                            width: 150px;
                            height: 150px;
                            margin-right: 10px;
                            margin-bottom: 10px;
                        }
                        @media (max-width: 360px) {
                            width: 74px;
                            height: 74px;
                        }
                        @media (max-width: 320px) {
                            width: 65px;
                            height: 65px;
                        }
                        &:nth-child(3n) {
                            margin-right: 0;

                        }
                    }
                }
                .share-img-flex0 {
                    li {
                        &:nth-child(2n ) {
                            margin-right: 20px;
                        }
                        &:nth-child(3n) {
                            margin-right: 5px;

                        }
                    }

                }
            }
        }

    }

</style>
<style lang="less">
    @import '../../assets/less/common';

    .share-item-left {
        /*width: 14%;
        margin-right: 4%;
        text-align: center;
        @media(min-width:780px){
            width: 98px;
        }*/
        span {
            color: @brick_red;
            font-size: 0.9rem;
            &.share-time-day {
                background: @brick_red;
                color: @font-primary;
                width: 100%;
                letter-spacing: 2px;
                .border-radius(4px);
                display: block;
                padding: 6px 0;
                margin-bottom: 5px;
                font-size: 0.6rem;
                line-height: 15px;
                em {
                    font-size: 200%;
                    font-style: normal;
                }
            }
            @media (min-width: 760px) {
                font-size: 1.4rem;
                &.share-time-day {
                    width: 100%;
                    margin-bottom: 5px;
                    font-size: 1.2rem;
                    line-height: 26px;
                    padding: 15px 0;

                }
            }
        }
    }

</style>
